import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { SeeAllLink } from '@components/basics/SeeAll';
import type { FragmentType } from '@graphql/reactQuery';
import type { SeeAllUserInfoFragmentDoc } from '@graphql/reactQuery';

export const ProfileFeedHeader = ({
  user,
  showSeeAll,
}: {
  user: FragmentType<SeeAllUserInfoFragmentDoc>;
  showSeeAll: boolean;
}) => {
  return (
    <Container>
      <Heading>Recent Activity</Heading>
      {showSeeAll && <SeeAllLink user={user} path="/activity" params={null} />}
    </Container>
  );
};

const Container = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',

  '@tabletLandscape': {
    gap: 8,
  },
});

const Heading = styled('h3', {
  title: 'M',
  fontWeight: 500,
  '@tablet': {
    title: 'L',
  },
});
